var map = {
	"./amazon.png": 1176,
	"./american_express.png": 5848,
	"./bain.png": 8485,
	"./bcg.png": 3115,
	"./bny_mellon.png": 6206,
	"./citi.png": 250,
	"./directi.jfif": 9207,
	"./facebook.png": 7139,
	"./flipkart.png": 6404,
	"./goldman_sachs.png": 2788,
	"./google.png": 2439,
	"./hexagon.png": 4806,
	"./hsbc.png": 182,
	"./ibm.png": 2318,
	"./iqvia.png": 656,
	"./jpmorgan.jfif": 8279,
	"./kotak.png": 1362,
	"./mckinsey.png": 9416,
	"./meta.png": 8432,
	"./microsoft.png": 8585,
	"./morgan_stanley.png": 9224,
	"./netflix.png": 1698,
	"./pwc.png": 1416
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4478;